document.addEventListener("DOMContentLoaded", () => {
	const header = document.querySelector('.header_main');
	const headerHeight = header.offsetHeight;
	const contentArea = document.querySelector('#inner-wrap');
	const headerOffset = header.offsetTop;

	window.addEventListener('scroll', () => {
		if (window.scrollY > headerOffset) {
			header.classList.add('sticky-header');
			contentArea.style.marginTop = headerHeight + 'px';
		} else {
			header.classList.remove('sticky-header');
			contentArea.style.marginTop = '0px';
		}
	});
});
